import { observable, action } from 'mobx';
import useMount from '../../utils/hooks/use-mount';
import useModal from '@src/utils/hooks/use-modal';
import UsModalStore from '@src/business-components/us-modal/store';
import UsModal from '@src/business-components/us-modal';

class FooterStore {
  @observable isComplete;

  usModalStore = new UsModalStore();

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  closeFooter = () => {};

  @action.bound
  backHome() {
    this.closeFooter();
    // window.scrollTo({
    //   top: 0,
    //   behavior: 'smooth'
    // });
  }

  showWxModal() {
    this.usModalStore.modalType = 2;
    this.usModalStore.isOpen = true;
    this.modals.usModal.open();
  }

  use() {
    this.modals = {
      usModal: useModal(UsModal, { store: this.usModalStore })
    };
    useMount(() => {});
  }
}
export default FooterStore;
